module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Devices/LTE#1-82a4ae17d00a0afc4a1985d788196d8302165fff41d6f4fc5cb24efa59f801e2.svg";